import { extend } from 'flarum/common/extend';

import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';

import type ItemList from 'flarum/common/utils/ItemList';

export default function removeAuthHeaderLinks() {
  extend(HeaderSecondary.prototype, 'items', function (items: ItemList) {
    items.remove('logIn');
    items.remove('signUp');
  });
}
